<ng-template [appTopbarTemplate]>
  <div class="title h4">{{ texts.title | localize }}</div>

  <div class="actions">
    <button class="btn btn-dark btn-round btn-sm" (click)="createModal.start()">
      <i class="fa-sharp fa-solid fa-plus me-2"></i> {{ texts.newJob | localize }}
    </button>
  </div>
</ng-template>

<div class="scroll-dummy" *ngIf="state == 'out'"></div>

<div class="content" [@fadeIn]="state">

  <!-- <div class="container mb-5">
    <div class="row align-items-center">
      <div class="col">
        <h3 class="mb-0">{{ texts.title | localize }}</h3>
      </div>
      <div class="col-auto">

        <button class="btn btn-dark btn-round" (click)="createModal.start()">
          <i class="fa-sharp fa-solid fa-stars me-2"></i> {{ texts.newJob | localize }}
        </button>

      </div>
    </div>
  </div> -->

  <div class="container-xl">

    <div class="row justify-content-end">
      <div class="col-12">

        <div class="card">


          <div class="card-header">

            <div class="row align-items-center">
              <div class="col">
                <div class="input-group input-group-flush input-group-merge">
                  <input type="search" name="q" [(ngModel)]="q" (ngModelChange)="searchSoon()" class="form-control search" [placeholder]="texts.searchPlaceholder | localize">
                  <div class="input-group-prepend ">
                    <div class="input-group-text">
                      <i class="fa-sharp fa-solid fa-magnifying-glass"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto">

                <div class="d-inline-block ms-2" ngbDropdown>
                  <button ngbDropdownToggle class="btn btn-sm btn-secondary">{{ texts.statusPrefix | localize }} {{ statusNames[status] | localize }} <i class="fa-solid fa-chevron-down ms-2"></i></button>
                  <div ngbDropdownMenu>
                    <div class="clickable" (click)="status = 'Imported'; reload();" ngbDropdownItem>
                      {{ texts.statusNames.Imported | localize }}
                    </div>
                    <div class="clickable" (click)="status = 'AnalysisRequested'; reload();" ngbDropdownItem>
                      {{ texts.statusNames.AnalysisRequested | localize }}
                    </div>
                    <div class="clickable" (click)="status = 'AwaitingOrder'; reload();" ngbDropdownItem>
                      {{ texts.statusNames.AwaitingOrder | localize }}
                    </div>
                    <div class="clickable" (click)="status = 'Sourcing'; reload();" ngbDropdownItem>
                      {{ texts.statusNames.Sourcing | localize }}
                    </div>
                    <div class="clickable" (click)="status = 'Completed'; reload();" ngbDropdownItem>
                      {{ texts.statusNames.Completed | localize }}
                    </div>
                    <div class="clickable" (click)="status = 'Paused'; reload();" ngbDropdownItem>
                      {{ texts.statusNames.Paused | localize }}
                    </div>
                    <div class="clickable" (click)="status = 'Cancelled'; reload();" ngbDropdownItem>
                      {{ texts.statusNames.Cancelled | localize }}
                    </div>
                    <div class="clickable" (click)="status = 'All'; reload();" ngbDropdownItem>
                      {{ texts.statusNames.All | localize }}
                    </div>

                  </div>
                </div>

                <div class="d-inline-block ms-2" ngbDropdown>
                  <button ngbDropdownToggle class="btn btn-sm btn-secondary">{{ texts.typePrefix | localize }} {{ typeNames[type] | localize }} <i class="fa-solid fa-chevron-down ms-2"></i></button>
                  <div ngbDropdownMenu>
                    <div class="clickable" (click)="type = 'Full'; reload();" ngbDropdownItem>
                      {{ texts.typeNames.Full | localize }}
                    </div>
                    <div class="clickable" (click)="type = 'Longlist'; reload();" ngbDropdownItem>
                      {{ texts.typeNames.Longlist | localize }}
                    </div>
                    <div class="clickable" (click)="type = 'All'; reload();" ngbDropdownItem>
                      {{ texts.typeNames.All | localize }}
                    </div>
                  </div>
                </div>

                <div class="d-inline-block ms-2" ngbDropdown>
                  <button ngbDropdownToggle class="btn btn-sm btn-secondary">{{ ownershipNames[ownership] | localize }} <i class="fa-solid fa-chevron-down ms-2"></i></button>
                  <div ngbDropdownMenu>
                    <div class="clickable" (click)="ownership = 'Self'; reload();" ngbDropdownItem>
                      {{ ownershipNames['Self'] | localize }}
                    </div>
                    <div class="clickable" (click)="ownership = 'Others'; reload();" ngbDropdownItem>
                      {{ ownershipNames['Others'] | localize }}
                    </div>
                    <div class="clickable" (click)="ownership = 'All'; reload();" ngbDropdownItem>
                      {{ ownershipNames['All'] | localize }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="card-body card-body-list">

            <div class="list-group" *ngIf="isLoading && !projects?.length">
              <div class="list-group-item py-3 px-3 fw-normal">
                <span>{{ texts.loading | localize }}</span>
              </div>
            </div>

            <div class="list-group" *ngIf="!isLoading && !projects?.length">
              <div class="list-group-item py-3 px-3 fw-normal">
                <span>{{ texts.empty | localize }}</span>
              </div>
            </div>

            <app-list-projects *ngIf="projects?.length" [projects]="projects" [language]="loc.language"></app-list-projects>

          </div>

          <div class="card-footer" *ngIf="hasMoreItems">
            <div class="row d-flex justify-content-center">
              <div class="col-auto">
                <a class="btn btn-secondary btn-round btn-sm" [class.loading]="isLoading" (click)="loadMore()">{{ texts.loadMore | localize }}</a>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>

</div>

<app-modal-create-project #createModal [language]="loc.language"></app-modal-create-project>

<!--<app-footer-blob></app-footer-blob>-->
